import React from "react";

export const LogoActive: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="30"
    height="16"
    viewBox="0 0 30 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.5335 0H16.1622V3.2428H22.5335C22.9774 3.2428 23.4027 3.32063 23.7973 3.46332L16.1622 11.3141V6.86826C16.1633 3.08175 13.0384 0 9.19678 0H2.82544V3.2428H9.19678C9.64068 3.2428 10.0659 3.32063 10.4605 3.46332L0.5 13.7069L2.82654 16L12.7195 5.82624C12.8203 6.15701 12.8751 6.50723 12.8751 6.86934V16H16.1633L26.0562 5.82624C26.157 6.15701 26.2119 6.50723 26.2119 6.86934V16H29.5V6.86934C29.5 3.08175 26.3752 0 22.5346 0H22.5335Z"
      fill="currentColor"
    />
  </svg>
);
